import React, { useEffect, useState } from "react";
import api from '../../../components/api'

const Modal = (props) => {

    var energia_id = props.energia_id

    // resumo

    const [areaConfortoR, setAreaConfortoR] = useState(0)
    const [areaEspecialR, setAreaEspecialR] = useState(0)
    const [areaExternoR, setAreaExternoR] = useState(0)
    const [areaInternoR, setAreaInternoR] = useState(0)
    const [areaTotalR, setAreaTotalR] = useState(0)
    const [areaTotalClimatizadaR, setAreaTotalClimatizadaR] = useState(0)
    const [areaTotalNaoClimatizadaR, setAreaTotalNaoClimatizadaR] = useState(0)

    const [lampIncandPercR, setLampIncandPercR] = useState(0)
    const [lampLEDPercR, setLampLEDPercR] = useState(0)
    const [lampFluoPercR, setLampFluoPercR] = useState(0)
    const [lampVaporPercR, setLampVaporPercR] = useState(0)
    const [tipoSistemaCentralPercR, setTipoSistemaCentralPercR] = useState(0)
    const [tipoSistemaUnitarioPercR, setTipoSistemaUnitarioPercR] = useState(0)

    //


    function carregaResumo() {

        //console.log(energia_id, 'aqui...')

        if (energia_id) {

            api.get(`energiaAmbienteResumo/${energia_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data[0]

                setAreaConfortoR(
                    data.areaConforto?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaEspecialR(
                    data.areaEspecial?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaExternoR(
                    data.areaExterno?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaInternoR(
                    data.areaInterno?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaTotalR(
                    data.areaTotal?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaTotalClimatizadaR(
                    data.areaTotalClimatizada?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setAreaTotalNaoClimatizadaR(
                    data.areaTotalNaoClimatizada?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setLampIncandPercR(
                    data.lampIncandPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setLampLEDPercR(
                    data.lampLEDPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setLampFluoPercR(
                    data.lampFluoPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setLampVaporPercR(
                    data.lampVaporPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setTipoSistemaCentralPercR(
                    data.tipoSistemaCentralPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );

                setTipoSistemaUnitarioPercR(
                    data.tipoSistemaUnitarioPerc?.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) ?? ''
                );



    
            }).catch((err) =>{
    
                console.log(err.response)
    
            })

        }

        


    }



    useEffect(() => {

        carregaResumo()

    }, [energia_id])

    return (

        <div>

                <div className="modal fade" id="modalAmbienteResumo" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Ambiente - Resumo</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">

                                <div class="col-md-12">

                                    <div className="table-responsive">

            
                                        <table width="100%" className="table table-bordered table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <td colSpan={3} style={{ backgroundColor: '#cef0ef'}}>
                                                    Área Total por Tipo de Climatização
                                                </td>
                                            
                                            </tr>
                                            </thead>
                                            <tbody>

                                            <tr>
                                                <td>
                                                    Climatizado Interno - Conforto: <b>{areaConfortoR} m<sup>2</sup></b>
                                                </td>
                                                <td rowSpan={2}>
                                                    Área Total Climatizada: <b>{areaTotalClimatizadaR} m<sup>2</sup></b>
                                                </td>

                                                <td rowSpan={4}>
                                                    Área Total: <b>{areaTotalR} m<sup>2</sup></b>
                                                </td>
                                                
                                            </tr>
                                            <tr>
                                                <td>
                                                    Climatizado Interno - Especial: <b>{areaEspecialR} m<sup>2</sup></b>
                                                </td>
                                                
                                            </tr>
                                            <tr>
                                                <td>
                                                    Não Climatizado - Interno: <b>{areaInternoR} m<sup>2</sup></b>
                                                </td>
                                                <td rowSpan={2}>
                                                    Área Total Não Climatizada: <b>{areaTotalNaoClimatizadaR} m<sup>2</sup></b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Não Climatizado - Externo: <b>{areaExternoR} m<sup>2</sup></b>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        <br/>

                                        <table width="100%" className="table table-bordered table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <td style={{ backgroundColor: '#e6e8cf'}}>
                                                    Uso Final de Iluminação por Tipo de Lâmpada
                                                </td>
                                            
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    LED: <b>{lampLEDPercR}%</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Fluorescente: <b>{lampFluoPercR}%</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Incandescente: <b>{lampIncandPercR}%</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Vapor metálico: <b>{lampVaporPercR}%</b>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        <br/>
                                        

                                        <table width="100%" className="table table-bordered table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <td style={{ backgroundColor: '#e8cfcf'}}>
                                                    Uso Final de Climatização por Tipo de Sistema de Climatização
                                                </td>
                                            
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    Central: <b>{tipoSistemaCentralPercR}%</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Unitário: <b>{tipoSistemaUnitarioPercR}%</b>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>

                            </div>
                                    

                            </div>
                            <div className="modal-footer">

                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}

export default Modal